import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1614243332/src/apps/webapp/src/components/products/ExploreProductAccordion/ExploreProductAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryBoundary"] */ "/codebuild/output/src1614243332/src/apps/webapp/src/components/ui/QueryBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1614243332/src/apps/webapp/src/containers/about-us/components/sections/TrendingProductsSection/TrendingProductsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1614243332/src/apps/webapp/src/containers/about-us/components/sections/TrendingProductsSection/TrendingProductsListSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1614243332/src/apps/webapp/src/containers/about-us/components/sections/TrendingProductsSection/TrendingProductSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1614243332/src/apps/webapp/src/containers/about-us/components/sections/TrendingProductsSection/TrendingProductSwiperSkeleton.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1614243332/src/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1614243332/src/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1614243332/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1614243332/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1614243332/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1614243332/src/packages/design-system/dist/index.mjs");
